import { StateCreator } from 'zustand';

import { AppConfigTypes } from '@/types/appConfigTypes';

export interface SettingsSlice {
  settings: AppConfigTypes | null;
  setSettings: (settings: AppConfigTypes) => void;
  showLoginPrompt: boolean;
  setShowLoginPrompt: (showLoginPrompt: boolean) => void;
  loginPromptMessage: string;
  setLoginPromptMessage: (message: string) => void;
}

export const appSettingsSlice: StateCreator<SettingsSlice> = (set) => ({
  settings: null,
  setSettings: (settings: AppConfigTypes | null) => set(() => ({ settings })),
  showLoginPrompt: false,
  setShowLoginPrompt: (showLoginPrompt: boolean) =>
    set(() => ({ showLoginPrompt })),
  loginPromptMessage: 'Please log in to continue',
  setLoginPromptMessage: (message: string) =>
    set(() => ({ loginPromptMessage: message })),
});
